import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { LocationDetailsSession } from "../../../api/models/locationDetailsSession";
import { UploadedImageInformation } from "../../../api/models/placardConfirmationSession";
import { ApiErrorCode, ServiceURLConstants } from "../../../constants/upplm.constants";
import { ERROR_IMG_FILE } from "../../../constants/upplm.constants.placardverification";
import { Address, PlacardImage, PlacardVerification } from "../../../interface/upplm.placardInformation";
import { TranslateDataPipe } from "../../../pipes/translation.pipe";
import { PlacardVerificationHelperService } from "../../../services/PlacardEditionServices/upplm.placardVerificationHelper.service";
import { UpplmApiService } from "../../../services/upplm.api.services";
import { UpsCommonService } from "../../../services/upplm.common.service";
import { StoredDataService } from "../../../services/upplm.storedData.service";
import { UpsDialogComponent } from "../../commonComponent/ups-dialog/ups-dialog.component";
import { UpsFileUploadComponent } from "../../commonComponent/ups-fileUpload/ups-fileUpload.component";

@Component({
    selector: 'editplacardverification',
    template: require('./editPlacardVerification.component.html'),
    providers: [PlacardVerificationHelperService]
})

export class EditPlacardVerification implements OnInit {

    showEditPlacardVerification: boolean = true;
    showNotificationChanges: boolean = false;
    errors: any[];
    @ViewChild('errorServerMessage', { static: false }) errorServerMessage: UpsDialogComponent;
    @Output() hideEditSection = new EventEmitter<boolean>();

    //--------------------------------------------------
    //variables to configure the control ups-fileUpload
    //--------------------------------------------------
    public validFileTypes = [
        'image/bmp',
        'image/gif',
        'image/jpeg',
        'image/png'
    ];
    //this variable is to load the list of files in component ups-fileUpload
    public fileList: Array<any> = [];
    // to call the functions in the component ups-fileUpload
    @ViewChild('fileUpload', { static: false }) fileUploadComponent: UpsFileUploadComponent;
    //--------------------------------------------------
    //variables to load files and event object ups-fileUpload
    //--------------------------------------------------
    formData: FormData = new FormData();
    filesUpload: Array<any> = [];
    files: Array<any> = [];
    fileStatus: string = '';
    ////--------------------------------------------------
    ////common
    ////--------------------------------------------------
    placardID: string = '';
    companyName: string = "";
    addressInformation: Address;
    placardDisplayed: boolean = true;
    placardImage: UploadedImageInformation;
    isLoading: boolean = false;
    ////--------------------------------------------------
    ////variables for component control modals
    ////--------------------------------------------------
    @ViewChild('awesomeDP', { static: false }) awesomeDP;
    messagesErrorServer: string = '';
    ////--------------------------------------------------
    ////validation
    ////--------------------------------------------------
    public imageEvent: string = '';
    public image: boolean = false;
    public displayToogleErrorMessage: boolean = false;

    constructor(
        private _storedDataService: StoredDataService,
        private _placardVerificationHelperService: PlacardVerificationHelperService,
        private _translatePipe: TranslateDataPipe,
        private _commonService: UpsCommonService,
        private _apiService: UpplmApiService
    ) {
        
    }

    ngOnInit() {

        this.bindDataFromStoredData(this._storedDataService.placardVerificationData, this._storedDataService.locationDetails);
        
    }

    bindDataFromStoredData(placardVerificationData: PlacardVerification, locationDetailsData: LocationDetailsSession) {

        this.placardID = this._storedDataService.placardId;
        this.companyName = locationDetailsData.companyName;
        this.addressInformation = {
            addressLine1: locationDetailsData.address1,
            cityTown: locationDetailsData.city,
            stateProvince: locationDetailsData.state,
            countryCode: locationDetailsData.countryKey,
            postalCode: locationDetailsData.postal
        };

        this.loadImageFromData(placardVerificationData.placardImage);
    }

    saveEdit() {
        this.isLoading = true;
        this.displayErrors();

        if (this.placardDisplayed && !this.imageHasChanged()) {
            this.cancel();
        }

        if (this.errors.length == 0) {
            this.checkIfUploadImageIsNecessary();
        }
        this.isLoading = false;
    }

    continueWithTheSaveProcess() {

        this.saveEditedDataToRequest();
        this.showNotificationsControl(true);
    }

    cancel() {
        this._storedDataService.clearEditingSections();
        this.hideEditSection.emit(true);
    }

    private displayErrors() {
        this.errors = [];
        this.displayToogleErrorMessage = false;

        if (!this.placardDisplayed) {
            this.displayToogleErrorMessage = true;
            this.errors = this.errors.concat(this.addError('placardDisplayed', this._translatePipe.transform('upplm.placardverification.mustconfirmplacarddisplayed'), 'required'));
        }

        if (this.imageHasChanged()) {
            this.isImageValid();
        }
    }

    private addError(id: string, field: string, condition: string): any {
        return [{
            "id": id,
            "displayText": field,
            "type": condition,
            "fieldName": "Name",
            "fieldError": "Name error",
            "fieldErrorDescription": "field Error"
        }];
    }

    focusInput(item: any) {
        document.getElementById(item.id).focus();
    }

    private saveEditedDataToRequest() {
        this._storedDataService.requestEditedData = this._placardVerificationHelperService.prepareSaveEditionRequest(this.buildObjectForPrepareRequest());
    }

    private buildObjectForPrepareRequest(): any {

        return {
            placardImage: this.placardImage
        };

    }

    private showNotificationsControl(show: boolean) {
        this.showEditPlacardVerification = !show;
        this.showNotificationChanges = show;
    }

    hideNotificationChange(showNotificationControl: boolean) {

        this.showNotificationsControl(showNotificationControl);

        if (this._storedDataService.isEditionComplete) {
            this.cancel();
        }
    }

    fileChange($event: any) {
        this.filesUpload = $event.file;
        this.fileStatus = $event.status;
        if (this.fileStatus === 'delete') {
            this.placardImage = null;
        }
    }

    setImageEvent(event: any) {
        this.imageEvent = event;
        if (event.startsWith('error')) {
            this.errors = [];
            this.isImageValid();
        }
    }

    isImageValid(): boolean {
        if (this.imageEvent === ERROR_IMG_FILE.ERROR_FILE_MAX) {
            this.fileUploadComponent.clear();
            this.filesUpload = [];
            this.addError('fileUpload', this._translatePipe.transform('upplm.placardverification.fileistoolarge'), 'required');
            return false;
        }

        if (this.imageEvent === ERROR_IMG_FILE.ERROR) {
            this.fileUploadComponent.clear();
            this.filesUpload = [];
            this.addError('fileUpload', this._translatePipe.transform('upplm.placardverification.filetypeinvalid'), 'invalidFormat');
            return false;
        }

        this.imageEvent = '';
        return true;
    }

    private loadImageFromData(image: PlacardImage) {

        if ( image !== null && image !== undefined) {
            let file = {
                fileName: image.name,
                fileContent: image.contents
            };
            this.fileList.push(file);
        }
    }

    private checkIfUploadImageIsNecessary() {
        if (this.filesUpload.length > 0) {

            this.filesUpload.forEach((file) => {
                this.formData.append('fileUPS', file.filesEvent, file.fileName);
            });

            this.formData.append('placardId', this.placardID);

            this._apiService.PostUploadServiceAPI(this._commonService.createURL(ServiceURLConstants.CREATE_PLACARD_CONFIRMATION, ApiErrorCode.CREATE_PLACARD_CONFIRMATION), this.formData).subscribe((response: any) => {
                this.placardImage = response.placardImage;

                this.formData = new FormData();

                this.continueWithTheSaveProcess();
            });
        } else {
            this.continueWithTheSaveProcess();
        }
    }

    private imageHasChanged(): boolean {

        let imageStored: string = '';
        let currentImage: string = '';

        if (this._storedDataService.placardVerificationData.placardImage) {
            imageStored = `${this._storedDataService.placardVerificationData.placardImage.name}.${this._storedDataService.placardVerificationData.placardImage.extension}`;
        }

        if (this.filesUpload.length > 0) {
            currentImage = this.filesUpload[0].fileName
        }

        if ((currentImage == "" && imageStored != "") || this.fileStatus == 'delete') {
            currentImage = `${this._storedDataService.placardVerificationData.placardImage.name}.${this._storedDataService.placardVerificationData.placardImage.extension}`;
        }

        return imageStored != currentImage;
    }

}